import Button from '@/components/Button';
import { useWebViewRouter } from '@/hooks/useWebViewRouter';
import { FormattedMessage } from 'react-intl';
import SkipButton from '../_components/SkipButton';
import LocaleSelection from '@/components/LocaleSelection/LocaleSelection';
import { Image } from '@/components/Image';
import { trackEvent } from '@/components/Event/_lib/eventTrack';

const PromotionPage = () => {
  const { direct } = useWebViewRouter();

  return (
    <>
      <div className="w-screen h-screen flex flex-col items-center fixed">
        <Image src="/images/bi.png" alt="bi" className="mt-[119px]" width={216} height={26} />
        <div className="h-[60px] mt-[46px] relative py-[20px] px-[32px] flex items-center justify-center rounded-[49px] bg-[#ffe3e3]">
          <Image
            src="/icons/triangle.svg"
            alt=""
            className="absolute -bottom-2 left-1/2 -translate-x-1/2 rotate-180 -z-[1]"
            width={20}
            height={10}
          />
          <span className="text-[20px] leading-7 font-bold z-[1]">
            <FormattedMessage id="onboarding_speechBubble" defaultMessage="Let's explore POCA!" />
          </span>
        </div>
        <Image src="/character/onboard.png" alt="character" width={380} height={380} />
        <span className="text-[20px] leading-7 font-medium mt-[30px] text-center">
          <FormattedMessage
            id="onboarding_description1"
            defaultMessage="Come and collect your favorite photocards through POCA."
          />
          <br />
          <FormattedMessage id="onboarding_description2" defaultMessage="I'll show you how! Come along." />
        </span>
        <div className="mt-[30px] flex items-center gap-[20px]">
          <div
            onClick={() =>
              trackEvent('Onboarding_Click_Skip', {
                Page: 'main'
              })
            }
          >
            <SkipButton />
          </div>
          <Button
            onClick={() => {
              trackEvent('Onboarding_Click_Start', {
                Page: 'main'
              });
              direct('/onboarding');
            }}
            data-primary
          >
            <FormattedMessage id="onboarding_button" defaultMessage="Start" />
          </Button>
        </div>
        <LocaleSelection />
      </div>
    </>
  );
};

export default PromotionPage;
